import React, {Component} from 'react';
import {Growl} from "primereact/growl";
import {CommonService} from "../../../service/commons/CommonService";
import {CaptureGuaranteesService} from "../../../service/ptt/captureGuarantees/CaptureGuaranteesService";
import {CAPTURE_LOANABLE_VALUES_ROUTE, VALUES_REQUEST_ROUTE} from "../../../utils/constants/RoutesConstants";
import {MAINTENANCE_INSTRUMENT} from "../../../utils/constants/Constants";
import AddInstrumentView from "./AddInstrumentView";
import {getSuggestedInAccount} from "../../../utils/calculate/Amount";


export default class AddInstrumentContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * Se toma el elemento a editar que viene de la pantalla anterior.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        this.commonService = new CommonService();
        this.captureGuaranteesService = new CaptureGuaranteesService();

        this.onChangeInputText = this.onChangeInputText.bind(this);
        this.validateEmisora = this.validateEmisora.bind(this);
        this.saveInstrument = this.saveInstrument.bind(this);
        this.returnPreviousPage = this.returnPreviousPage.bind(this);
        this.loading = this.loading.bind(this);
        this.setStateForScreen = this.setStateForScreen.bind(this);

        let addGuarantee = this.props.location.state.addGuarantee === undefined ? false : this.props.location.state.addGuarantee;
        let loanId = this.props.location.state.loanId === undefined ? '' : this.props.location.state.loanId;
        let loanAmount = this.props.location.state.loanAmount === undefined ? '' : this.props.location.state.loanAmount;
        let guaranteeAmount = this.props.location.state.guaranteeAmount === undefined ? '' : this.props.location.state.guaranteeAmount;
        let account = this.props.location.state.account === undefined ? '' : this.props.location.state.account;

        this.state = {
            callScreen: this.props.location.state.callScreen,
            returnPath: this.props.location.state.returnPath,
            addGuarantee: addGuarantee,
            loanId: loanId,
            loanAmount: loanAmount,
            guaranteeAmount: guaranteeAmount,
            suggested: 0,
            instrumentData: {
                tipoValor: '',
                emisora: '',
                serie: '',
                cuenta:account
            },
            isValidEm: false,
            isLoading: false,
            title: '',
            returnPage: '',
        };
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    componentDidMount() {
        this.setStateForScreen(this.state.callScreen);
    }

    setStateForScreen(screen) {
        let pageName = this.state.addGuarantee ? 'Agregar Garantía' : 'Alta Emisión';
        let titleScreen = '';
        if(screen === 'controlPanel'){
            titleScreen = 'Tablero de Control \\ Agregar Garantía ';
        }else if (screen === 'orderLender'){
            titleScreen = 'Prestamista \\ Captura de Valores Prestables \\ Postura Rápida \\ ' + pageName ;
        }else if (screen === MAINTENANCE_INSTRUMENT){
            titleScreen = 'Mantenimiento \\ Emisoras \\ Alta Emisión';
        } else{
            titleScreen = 'Prestatario \\ Solicitud de Valores \\ Insertar Postura \\ ' + pageName;
        }

        this.setState({
                title: titleScreen,
                returnPage:
                    screen === 'orderLender' ?
                        CAPTURE_LOANABLE_VALUES_ROUTE :
                        VALUES_REQUEST_ROUTE,
            }
        );
    }

    /**
     * Función que maneja el cambio de valor en los campos de texto
     * y los coloca en el state dentro del objeto que se va a editar.
     * @param event Contiene el valor que fue modificado en la vista.
     */
    onChangeInputText(event) {
        const {name, value} = event.target;
        let instrumentDataAux = this.state.instrumentData;
        instrumentDataAux[name] = value;
        this.setState({instrumentData: instrumentDataAux,})
    }


    /**
     * Función que realiza una consulta al back para validar si
     * los datos ingresados para la emisora son válidos.
     * Si son válidos, regresa la información de la emisora
     * y agregar una nueva posición.
     */
    validateEmisora() {
        if ((this.state.instrumentData.tipoValor !== "") &&
            (this.state.instrumentData.emisora !== "") &&
            (this.state.instrumentData.serie !== "")) {
            this.loading(true);
            this.commonService.getInstrumentData(
                this.state.instrumentData.emisora,
                this.state.instrumentData.serie,
                this.state.instrumentData.tipoValor,
                this.state.loanId
            ).then(
                data => {
                    if (data.message && data.message !== '') {
                        this.growl.show({severity: 'error', summary: 'Error.', detail: data.message});
                        this.setState({isLoading: false,});
                        return;
                    }
                    if (data.error && data.error !== '') {
                        this.growl.show({severity: 'error', summary: 'Error.', detail: data.error});
                        this.setState({isLoading: false,});
                        return;
                    }
                    let emObject = data.payload[0];
                    let instrumentDataAux = this.state.instrumentData;
                    instrumentDataAux['cupon'] = emObject['cupon'];
                    instrumentDataAux['isin'] = emObject['isin'];
                    instrumentDataAux['precio'] = emObject['precio24'];
                    instrumentDataAux['precioDescontado'] = emObject['precio24Descontado'];
                    instrumentDataAux['fechaVence'] = emObject['fechaVence'];
                    instrumentDataAux['aforoPorc'] = emObject['aforoPorc'];
                    this.setState({
                        isValidEm: true,
                        instrumentData: instrumentDataAux,
                        suggested: getSuggestedInAccount(this.state.loanAmount, this.state.guaranteeAmount, emObject['precio24Descontado']),
                    })
                }
            );
            this.loading(false);
        } else {
            this.setState({isValidEm: false,});
            this.growl.show({severity: 'error', summary: 'Error.', detail: 'Llenar los campos requeridos'});
        }
    }

    /**
     * Función que consume a CaptureGuaranteesService para guardar los datos
     * del elemento nuevo.
     * Se hace una validación que estén presentes los datos obligatorios.
     */
    saveInstrument() {
        this.validateEmisora();
        if (this.state.isValidEm) {
            this.captureGuaranteesService.saveEmisora(this.state.instrumentData)
                .then(res => {
                    if (res.message && res.message === 'Success') {
                        let message = {
                            severity: 'success',
                            summary: 'Éxito',
                            detail: 'La emisora ha sido insertada correctamente.',
                        };
                        this.returnPreviousPage(message);
                    } else if (res.error && res.error !== '') {
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: res.error
                        });
                    }
                });
        } else {
            this.growl.show({severity: 'error', summary: 'Error.', detail: 'Llenar los campos requeridos'});
        }
    }

    /**
     * Función que regresa a la pantalla de Captura de Garantías
     */
    returnPreviousPage(message) {
        this.setState({isLoading: false,});
        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
            state: {
                returnPath: this.state.returnPage,
                selectedLoanControlPanel: this.props.location.state.selectedLoan,
                folio: this.props.location.state.loanId,
                amount: this.state.loanAmount,
                maturity: this.props.location.state.maturity,
                loanAmount: this.props.location.state.loanAmount,
                borrowerAccount: this.state.instrumentData.cuenta,
                status: this.props.location.state.status ? this.props.location.state.status : '',
            }
        });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {instrumentData, isLoading} = this.state;

        return (
            <AddInstrumentView
                instrumentData={instrumentData}
                messagesGrowl={messagesGrowl}
                isLoading={isLoading}
                loading={this.loading}
                title={this.state.title}
                onChangeInputText={this.onChangeInputText}
                validateEmisora={this.validateEmisora}
                saveInstrument={this.saveInstrument}
                returnPreviousPage={this.returnPreviousPage}
                addGuarantee={this.state.addGuarantee}
                account={this.state.account}
                suggested={this.state.suggested}
            />
        );
    }
}
